import React, { FC, useMemo } from 'react';

import { ApolloClient, ApolloProvider } from '@apollo/client';

import { SandboxApolloLink, sandboxStore } from 'sandbox';

import { ApolloContext } from './constants';
import { IApolloProviderProps } from './interfaces';

export const CustomApolloProvider: FC<IApolloProviderProps> = ({
  children,
  cache,
}) => {
  const client = useMemo(
    () =>
      new ApolloClient({
        cache,
        link: new SandboxApolloLink(sandboxStore),
        connectToDevTools: false,
        defaultOptions: {
          watchQuery: { errorPolicy: 'all' },
          query: { errorPolicy: 'all' },
          mutate: { errorPolicy: 'none' },
        },
      }),
    [cache]
  );

  return (
    <ApolloProvider client={client}>
      <ApolloContext.Provider value={{}}>{children}</ApolloContext.Provider>
    </ApolloProvider>
  );
};
